<template>
  <el-dialog :title="dialogName" :visible.sync="dialogVisible" top="80px" :close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true" width="705px">
    <div class="main-box">
      <el-form  ref="dataForm" id="dataForm" class="main-form" :model="temp" :rules="rules" label-width="100px" label-suffix="：">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item  label="标题" >
              <el-input  v-model="temp.title" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item  label="创建人" >-->
<!--              <el-input  v-model="temp.createByName" :disabled="true"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="12">
            <el-form-item  label="创建时间" >
              <el-input  v-model="temp.createdTime" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="内容" >
              <el-input type="textarea"  v-model="temp.content" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </div>
    <div slot="footer" class="dialog-footer">
      <xr-button type="primary" @click="toView()">办理</xr-button>
    </div>
  </el-dialog>
</template>

<script>



  export default {
    name: "messageListDialog",
    data (){
      return {
        // calculationMethodList:[],
        // surchargeTypeList:[],
        dialogName: '查看信息',
        dialogVisible: false,
        temp:{
          createdByName:'', //创建人
          createdTime:'', //创建时间
          title:'',       //标题
          content:'',     //内容
        },
        associationView: '',// 绑定页面
        rules:{}
      }
    },
    components: {

    },
    created(){

    },
    methods: {
      init(id) {
        this.resetTemp()
        this.dialogVisible = true;
        this.initInfo(id);
      },

      // 获取内容
      initInfo(id){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tMetalSendMessage_findById',
            id: id,
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          const data = response.data;
          console.log(data)
          this.temp.createdByName = data.createdByName
          this.temp.createdTime = data.createdTime
          this.temp.title = data.title
          this.temp.content = data.content
          this.temp.content = data.content
          this.associationView = data.associationView
        })

      },

      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
      },
      //重置
      resetTemp() {
        this.temp.createdByName = ''
        this.temp.createdTime = ''
        this.temp.title = ''
        this.temp.content = ''
        this.associationView = ''
      },
      // 跳转
      toView(){
        // 获取跳转页面参数


        // 关闭页面 进行跳转
        this.dialogVisible = false;
        this.$emit('closeDialog');
        console.log(this.associationView)
        let path = this.associationView
        this.$router.push(path)
      }
    },
  }
</script>
<style>

</style>





// WEBPACK FOOTER //
// src/views/base/message/message-info-dialog.vue